<template>
  <div class="data_card" :style="{ backgroundColor: cardColor }">
    <!-- Loader overlay -->
    <div v-if="loading" class="loader-overlay">
      <v-progress-circular
        indeterminate
        color="primary"
        size="50"
      ></v-progress-circular>
    </div>

    <div class="extra_icon_slot">
      <slot name="extra-icon"></slot>
    </div>

    <!-- TOP ROW -->
    <div class="main_data_card">
      <div class="text_content">
        <h5>
          <v-icon color="#0d47a1" size="17">mdi-circle</v-icon>
          {{ $t("labels.finances.payments") }}
        </h5>
        <h5>
          <v-icon color="orange" size="17">mdi-circle</v-icon>
          {{ $t("labels.finances.discounts") }}
        </h5>
        <h5>
          <v-icon color="#ef5350" size="17">mdi-circle</v-icon>
          <!-- {{ $t("labels.finances.Dues") }} -->
          {{ $t("labels.finances.remaining") }}
        </h5>
        <!-- <h5 v-if="!$route.query.months">
          <v-icon color="green" size="17">mdi-circle</v-icon>
          {{ $t("labels.finances.total_subscriptions") }}
        </h5> -->
      </div>

      <div class="text_content">
        <h5>{{ titles[0] }}</h5>
        <h5>{{ titles[1] }}</h5>
        <h5>{{ titles[2] }}</h5>
        <!-- <h5 v-if="!$route.query.months">{{ titles[3] }}</h5> -->
      </div>
    </div>

    <!-- SECOND ROW -->
    <div class="desc_row">
      <v-icon size="40" @click="showAlert()" color="primary">
        {{ `mdi-${icon}` }}
      </v-icon>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="primary"
            size="40"
            role="button"
            dark
            v-bind="attrs"
            v-on="on"
            @click="push"
          >
            mdi-arrow-left-box
          </v-icon>
        </template>
        <span> عرض {{ $t("breadcrumb.finances.teams") }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "DataCard",
  props: {
    url: { type: String, default: "" },
    titles: { type: Array, required: true },
    desc: String,
    icon: String,
    cardColor: { type: String, default: "#fff" },
    loading: { type: Boolean, default: true }, // 👈 NEW PROP
  },
  methods: {
    push() {
      this.$router.push({
        path: this.url,
        query: { months: this.$route.query.months },
      });
    },
    showAlert() {
      alert("Icon clicked!");
    },
  },
  mounted() {
    // console.log("this.loading in card", this.loading);
  },
};
</script>

<style scoped lang="scss">
.data_card {
  position: relative;
  box-shadow: 0 14px 54px 0 rgba(0, 0, 0, 0.05);
  padding: 20px 15px;
  border-radius: 12px;
  border: 2px solid var(--main);
  overflow: hidden;
  transform: scale(1.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  }

  .main_data_card {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .text_content {
    flex: 1 1 auto;
    min-width: 0;
  }

  .desc_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 12px;
  }

  .extra_icon_slot {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-right: 10px;
  }
}

/* Loader overlay */
.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
</style>
